export default __webpack_public_path__ + "static/media/Kelly_Cole_AHV_In_Moms_We_Trust.de2f1ebc.jpg";